import React, { useContext } from 'react';
import { compose } from 'redux';
import { useSelector } from 'react-redux';
import { getCurrentUserHasCore } from '@wix/da-shared-react/pkg/publicSession/selectors';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks';
import { ShopItemType } from '../../../../../types/shop';
import withSectionFetchSpinner from '../../../../decorators/withSectionFetchSpinner';
import ShopGrid from '../ShopGrid';
import PremiumFolderCreateButton from '../_partials/PremiumFolderCreateButton';
import PremiumFoldersEmptyState from '../_partials/PremiumFoldersEmptyState';
import { isCurrentUserProfileOwner } from '../../../../selectors/users';
import GetCore from '../_partials/GetCore';

import commonStyles from '../ShopSection.scss';
import s from './ShopPremiumFolders.scss';

export interface Props {
  className?: string;
  total: number;
}

const enhance = compose(withSectionFetchSpinner);

export const ShopPremiumFolders: React.FC<Props> = ({ className, total }) => {
  const isMobile = useContext(MobileContext);
  const isOwner = useSelector(isCurrentUserProfileOwner);
  const hasCoreMembership = useSelector(getCurrentUserHasCore);
  const isPaywalUpdates = useFlag('paywall_updates');

  // show Add New button to owners only who already have CORE
  const showAddNew = hasCoreMembership && isOwner && !isMobile;
  // show GetCore to owner who doesnt have CORE yet.
  const showGetCore = !hasCoreMembership && isOwner;

  return (
    <div className={commonStyles['section-with-no-header']}>
      {!isPaywalUpdates && showAddNew && (
        <PremiumFolderCreateButton className={s['create-button']} />
      )}
      {!isPaywalUpdates && showGetCore && <GetCore className={s['get-core']} />}
      <ShopGrid
        className={className}
        itemType={ShopItemType.PREMIUM_FOLDERS}
        emptyState={<PremiumFoldersEmptyState view={'large'} />}
      />
    </div>
  );
};
ShopPremiumFolders.displayName = 'ShopPremiumFolders';

export default enhance(ShopPremiumFolders) as React.ComponentType<Props>;
